module.exports = __webpack_public_path__ + "img/claimed-en.0d833e8c.png";